import { connect } from 'react-redux'
import { branch, compose, renderNothing } from 'recompose'

import {
  selectCurrentHelocs,
  selectCurrentCELs
} from 'src/store/selectors/home/loans'
import { selectPaidInFull } from 'src/store/selectors/home/answers'
import { addHomeAnswer } from 'src/actions/home'
import { openLoans } from 'src/actions/homeowner'
import { addLoan } from 'src/actions/loan'
import { withElementRef } from 'src/composables'
import { NoLoansPanel } from 'src/constants/notificationRefs'

const NoLoansPanelContainer = compose(
  connect(
    state => ({
      paidInFull: selectPaidInFull(state),
      currentCELCount: selectCurrentCELs(state).length,
      currentHelocCount: selectCurrentHelocs(state).length
    }),
    dispatch => ({
      addLoan: () => {
        dispatch(openLoans())
        dispatch(addLoan())
      },
      markPaidInFull: () =>
        dispatch(
          addHomeAnswer({
            question: 'isHomePaidInFull',
            answer: true
          })
        )
    })
  ),
  branch(
    ({ paidInFull, currentCELCount }) => currentCELCount || paidInFull,
    renderNothing
  ),
  withElementRef(NoLoansPanel)
)

export default NoLoansPanelContainer
